export const COLLECTIONS_LIST_ID = 'collection-list';
export const COLLECTIONS_CONTAINER_ID = 'collections_container';
export const MAX_ASSET_COUNT_TO_LOAD = 100;
